import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import { linkedBrokersMessageOf } from "../../../utils";
import { ErrorPanel, ErrorPanelHeader } from "../ErrorPanel";
import { BLOCKED_LABELS } from "./constants";
import { LinkedBrokersBlockProps } from "./types";

export const LinkedBrokersBlock = ({
  brokers,
  action = "delete",
}: LinkedBrokersBlockProps) => (
  <ErrorPanel role="alert" aria-label={BLOCKED_LABELS[action]}>
    <ErrorPanelHeader>
      <WarningAmberRoundedIcon aria-hidden="true" />
      {linkedBrokersMessageOf(brokers, action)}
    </ErrorPanelHeader>
  </ErrorPanel>
);
